<template>
  <nav
       id="sidebar-wrapper"
       class="text-left text-danger font-weight-bolder shadow side-nav"
       style="width: 140px; height: calc(100vh - 133px)"
  >
    <div class="">
      <div class="pt-2 text-center">Main Menu</div>
      <hr class="my-1"/>
      <ul class="nav flex-column h-100p text-small">
        <li class="nav-item">
          <router-link :to="{name: 'UserIndex' }"
                       tag="a"
                       class="nav-link text-dark"
                       :class="{'active': isActiveRoute('User')}"
                       role="tab"
                       data-toggle="list">
            Users
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'DocumentIndex' }"
                       tag="a"
                       class="nav-link text-dark"
                       :class="{'active': isActiveRoute('DocumentIndex')}"
                       role="tab"
                       data-toggle="list">
            Documents
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'PortIndex' }"
                       tag="a"
                       class="nav-link text-dark"
                       :class="{'active': isActiveRoute('PortIndex')}"
                       role="tab"
                       data-toggle="list">
            Ports
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'ClinicIndex' }"
                       tag="a"
                       class="nav-link text-dark"
                       :class="{'active': isActiveRoute('ClinicIndex')}"
                       role="tab"
                       data-toggle="list">
            Clinics
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'InjuryIndex' }"
                       tag="a"
                       class="nav-link text-dark"
                       :class="{'active': isActiveRoute('InjuryIndex')}"
                       role="tab"
                       data-toggle="list">
            Injury/Illness
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'CountryIndex' }"
                       tag="a"
                       class="nav-link text-dark"
                       :class="{'active': isActiveRoute('CountryIndex')}"
                       role="tab"
                       data-toggle="list">
            Countries
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'HospitalIndex' }"
                       tag="a"
                       class="nav-link text-dark"
                       :class="{'active': isActiveRoute('HospitalIndex')}"
                       role="tab"
                       data-toggle="list">
            PCR Clinic
          </router-link>
        </li>

        <li class="nav-item">
          <router-link :to="{name: 'AnnouncementIndex' }"
                       tag="a"
                       class="nav-link text-dark"
                       :class="{'active': isActiveRoute('Announcement')}"
                       role="tab"
                       data-toggle="list">
            Announcement
          </router-link>
        </li>

        <li class="nav-item">
          <router-link :to="{name: 'AdminAnnouncementIndex' }"
                       tag="a"
                       class="nav-link text-dark"
                       :class="{'active': isActiveRoute('AdminAnnouncement')}"
                       role="tab"
                       data-toggle="list">
            Admin Announcement
          </router-link>
        </li>

      </ul>
    </div>
  </nav>
</template>

<script>
import { vueAppMixin } from "@/mixins/vueAppMixin";

export default {
name: "AdminSideNav",
  mixins: [ vueAppMixin]
}
</script>

<style scoped>
.nav-link.active, .nav-link:hover  {
  background-color: #e87c87;
  color: white !important;
}
</style>
